var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    d: "M33.414 16.414a2 2 0 0 0 0-2.828L20.686.858a2 2 0 1 0-2.828 2.828L29.172 15 17.858 26.314a2 2 0 1 0 2.828 2.828zM0 17h32v-4H0z"
  })));
};
export default SvgForward;